import { AuthProvider } from "#/providers/AuthProvider";
import { ClientProvider } from "#/providers/ClientProvider";
import { GoogleMapProvider } from "#/providers/GoogleMapProvider";
import AppRoutes from "#/routes/AppRoutes";
import { PublicClientApplication } from "@azure/msal-browser";
import { MsalProvider } from "@azure/msal-react";
import { MantineProvider } from "@mantine/core";
import { Notifications } from "@mantine/notifications";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { ErrorBoundary } from "react-error-boundary";
import { useTranslation } from "react-i18next";
import { BrowserRouter } from "react-router-dom";
import { msalConfig } from "./config/msalConfig";
import "./i18n";
import mantineTheme from "./theme/mantineTheme";

function ErrorFallback() {
  const { t } = useTranslation();
  return (
    <div className="bg-background flex min-h-screen items-center justify-center">
      <div className="text-center">
        <h1 className="mb-4 text-4xl font-bold">
          {t("common.somethingWentWrong")}
        </h1>
        <p className="text-muted-foreground">
          {t("common.pleaseTryAgainLater")}
        </p>
      </div>
    </div>
  );
}

export default function App() {
  return (
    <ErrorBoundary FallbackComponent={ErrorFallback}>
      <GoogleMapProvider>
        <QueryClientProvider client={new QueryClient()}>
          <MsalProvider instance={new PublicClientApplication(msalConfig)}>
            <BrowserRouter>
              <ClientProvider>
                <AuthProvider>
                  <MantineProvider theme={mantineTheme}>
                    <Notifications />
                    <AppRoutes />
                  </MantineProvider>
                </AuthProvider>
              </ClientProvider>
            </BrowserRouter>
          </MsalProvider>
        </QueryClientProvider>
      </GoogleMapProvider>
    </ErrorBoundary>
  );
}
